import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ApiService } from './api.service';
import { environment } from '@env/environment';

import { NotificationService } from '../notification.service';

import {
  IStudentAnswerDTO,
  IStudentAnswerRequestDTO,
} from '@app/infrastructure/models/answer';

@Injectable({
  providedIn: 'root',
})
export class StudentAnswerService {
  private controllerRoute: string = 'students';
  private url: string = `${environment.apiRoute}`;
  constructor(
    private apiService: ApiService,
    private notificationService: NotificationService,
  ) {
    this.url = `${environment.apiRoute}/${this.controllerRoute}`;
  }

  public getStudentAnswerList(
    studentAssignmentId: number,
    studentId: string,
  ): Observable<IStudentAnswerDTO[]> {
    const endpoint = `${this.url}/${studentId}/assignments/${studentAssignmentId}/answers`;
    return this.apiService.get<IStudentAnswerDTO[]>(endpoint);
  }

  public createStudentAnswer(
    studentAssignmentId: number,
    studentId: string,
    payload: IStudentAnswerRequestDTO,
  ): Observable<IStudentAnswerDTO> {
    const endpoint = `${this.url}/${studentId}/assignments/${studentAssignmentId}/answers`;

    return this.apiService.post<IStudentAnswerDTO, IStudentAnswerRequestDTO>(
      endpoint,
      payload,
    );
  }

  public updateStudentAnswer(
    studentAssignmentId: number,
    studentId: string,
    payload: IStudentAnswerDTO,
  ): Observable<IStudentAnswerDTO> {
    const endpoint = `${this.url}/${studentId}/assignments/${studentAssignmentId}/answers/${payload.id}`;

    return this.apiService.patch<IStudentAnswerDTO, IStudentAnswerDTO>(
      endpoint,
      payload,
    );
  }

  public updateStudentAnswerList(
    studentAssignmentId: number,
    studentId: string,
    dayBlockId: number,
    payload: IStudentAnswerDTO[],
  ): Observable<IStudentAnswerDTO[]> {
    const endpoint = `${this.url}/${studentId}/assignments/${studentAssignmentId}/answers/blocks/${dayBlockId}`;

    return this.apiService.put<IStudentAnswerDTO[], IStudentAnswerDTO[]>(
      endpoint,
      payload,
    );
  }
}
